import SectionMixin from '@/mixins/sectionMixin'

//formulajs calc
import {IRR, NOMINAL} from '@formulajs/formulajs'

export default {
    name: 'vtu-simulator-cdt',
    mixins: [SectionMixin],
    props:{
      data: {
      type: Object,
      required: true
    }
    },
    
    data() {
        const d = this.data;
        return {
            amount: 10000000,
            lastValidAmount: 10000000,
            cdtTable: d.cdt_table || [],
            uvtAccount: d.uvt_value || 0,
            factorAccount: d.factor_value || 0,
            rteAccount: d.rte_value || 0,
            showError: false,
            selectDay: 360,
            selectedAccountTerm: 1,
        }
    },
    created(){

        const defaultSelectDay = this.cdtTable.some(item => item.days === 360);

        if (!defaultSelectDay && this.cdtTable.length > 0) {
            this.selectDay = this.cdtTable[0].days;
        }
    },

    mounted() {
        this.wording = this.$store.state.wording.data.attributes
    },

    methods: {

        calculateEA: function(currentRate){
            const toNominal = currentRate/100;
            return toNominal;
        },

        calculateMV: function(EA, days){
            if (!days || days === 0) return 0;
            const n = 365 / days;
            return (Math.pow(1 + EA, 1/n) - 1) * n * 100;
        },

        calculateTable: function({ amount, days, MV }) {
            
            const dailyRate = (MV / 100) / 365;
            const dailyInterest = amount * dailyRate;
            const totalInterest = dailyInterest * days;
            const baseRte = (this.uvtAccount * this.factorAccount);
            const rtePercentage = (this.rteAccount / 100);
    
            return {
                dailyInterest: dailyInterest,
                interest: totalInterest,
            };
        },
        
        calculateMonthlyTIR: function(cashFlow) {
            return IRR(cashFlow);
        },

        getAccountCalculations(eaRate){
            const EA = this.calculateEA(eaRate)
            const MV = this.calculateMV(EA, this.selectDay)
            const data = this.calculateTable({ amount: this.amount , days: this.selectDay, MV: MV})
            const Interest = data.interest
            const Rte = (Interest * 0.04)
            const Total = this.amount + Interest - Rte
            const cashFlow = [this.amount * -1, Total];
            const periodIRR = this.calculateMonthlyTIR(cashFlow);
            const monthlyTIR = (Math.pow(1 + periodIRR, 30 / this.selectDay) - 1) * 100;
            
            return {
              EA: eaRate,
              MV: MV.toFixed(2),
              FirstDailyInterest: data.dailyInterest,
              Interest,
              Rte,
              Total,
              MonthlyTIR: monthlyTIR.toFixed(3),
            };
        },

        validateMinAmount() {
            const minValue = 100000;
            if (this.amount < minValue) {
                this.amount = minValue;
            }
        },

    },

    computed:{

        title() { return this.data.title },
        subtitle() { return this.data.subTitle },
        inputPlaceholder() { return this.data.inputPlaceholder },
        infoField() { return this.data.infoField },
        questions() { return this.data.questions },

        currentTier() {
            return this.cdtTable.find(item => item.days === this.selectDay) || {};
        },

        currentRateStandard() {
            return this.currentTier.rate || 0;
        },
        currentRatePro() {
            return this.currentTier.rate_pro || 0;
        },

        accountTermOptions() {
            return [
                { value: 1, label: 'Al final'},
                { value: 2, label: 'Mensual' }
            ];
        },

        accountStandard(){
            return this.getAccountCalculations(this.currentRateStandard)
        },
        accountPro(){
            return this.getAccountCalculations(this.currentRatePro)
        },
    },

    watch: {
        amount(newValue) {
            const maxValue = 9999999999;
            if (!newValue) {
                this.lastValidAmount = 0;
                return;
            }
            if (newValue >= maxValue) {
                this.amount = this.lastValidAmount; 
            } else {
                this.lastValidAmount = newValue;
            }
        }
    }
}